import type { FC } from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as firstPencilSelectors from '@makemydeal/dr-dash-store/selectors/firstPencilSelectors';

import { IncentiveTotalsView } from '../rebates/IncentiveTotalsView';
import { getFirstPencilIncentiveTotals, withIncentiveOverrideAmounts } from './utils';
import { useSelectedProgramIncentiveRows } from './useFirstPencilIncentiveRows';
import type { FirstPencilProgramsOfferType } from './types';

type FirstPencilIncentiveTotalsProps = {
    offerType: FirstPencilProgramsOfferType;
};

export const FirstPencilIncentiveTotals: FC<FirstPencilIncentiveTotalsProps> = ({ offerType }) => {
    const manualIncentives = useSelector(firstPencilSelectors.getManualIncentives);
    const overrides = useSelector(firstPencilSelectors.getIncentiveOverrides);
    const incentives = useSelectedProgramIncentiveRows(offerType);
    const { dealerCashTotal, incentivesTotal } = useMemo(
        () => getFirstPencilIncentiveTotals(withIncentiveOverrideAmounts(incentives, overrides), manualIncentives),
        [incentives, overrides, manualIncentives]
    );

    return <IncentiveTotalsView dealerCashTotal={dealerCashTotal} incentivesTotal={incentivesTotal} />;
};
